import React from 'react';
import './selection-checkbox.css';

/**
 * Case à cocher contrôlée des lignes et des groupes (états coché / partiel)
 */
export default function SelectionCheckbox({
  checked,
  indeterminate = false,
  onChange,
  title,
  disabled = false,
}) {
  const isActive = checked || indeterminate;

  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={indeterminate ? 'mixed' : checked}
      title={title}
      disabled={disabled}
      className={`agv-selection-checkbox ${isActive ? 'agv-selection-checkbox--checked' : ''}`}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onChange(!checked);
      }}
    >
      {checked && '✓'}
      {!checked && indeterminate && '–'}
    </button>
  );
}
